import { render, staticRenderFns } from "./commercial.vue?vue&type=template&id=7f637eb0"
import script from "./commercial.vue?vue&type=script&lang=ts"
export * from "./commercial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports